import { addDays, startOfDay } from 'date-fns';
import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DropDownVariant, QPointDateTimePickerComponent, QPointInlineEditingInputComponent, QPointMultiViewDateRangePickerComponent, QPointReactiveFormInputGroupComponent, QPointSuggestlistComponent } from '../../../projects/qpoint-forms/src/public_api';
import { QPointContentContainerComponent, QPointToolbarButtonComponent, QPointToolbarComponent } from '@qpoint/layout';
import { QPointValidationFormDirective, QPointFormControlDirective } from '../../../projects/qpoint-forms/src/lib/form-validation';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { QPointDateFormat, QPointDateFormatService } from '@qpoint/i18n';

@Component({
    selector: "qpoint-form-validation-demo",
    templateUrl: "./form-validation-demo.component.html",
    styleUrls: ["./form-validation-demo.component.scss"],
    imports: [
        QPointToolbarComponent,
        QPointToolbarButtonComponent,
        QPointContentContainerComponent,
        FormsModule,
        ReactiveFormsModule,
        QPointReactiveFormInputGroupComponent,
        QPointValidationFormDirective,
        QPointFormControlDirective,
        QPointInlineEditingInputComponent,
        QPointSuggestlistComponent,
        QPointFormControlDirective,
        QPointSuggestlistComponent,
        AsyncPipe,
        QPointDateTimePickerComponent,
        QPointMultiViewDateRangePickerComponent
    ]
})
export class FormValidationDemoComponent implements AfterViewInit, OnDestroy {
  protected readonly DropDownVariant = DropDownVariant;
  data$: BehaviorSubject<object[]> = new BehaviorSubject<object[]>([]);
  initialData = [
    { id: 1, identifier: "eins" },
    { id: 2, identifier: "zwei" },
  ];

  readonly minDate = addDays(startOfDay(new Date()), 5);
  readonly maxDate = addDays(startOfDay(new Date()), 10);

  form: UntypedFormGroup = this.fb.group({
    username: [null, [Validators.required, Validators.maxLength(10)]],
    password: [null, [Validators.required]],
    drop1: [null, [Validators.required]],
    drop2: [null, [Validators.required]],
    drop3: [null, [Validators.required]],
    datePicker: [new Date(), [Validators.required]],
    dateTimePicker: [new Date(), [Validators.required]],
    dateRangePicker: [{ start: new Date(), end: new Date() }, [Validators.required]],
    dateTimePickerMinMax: [this.minDate, [Validators.required, this.dateValidatorMinMax()]],
    inlineEdit: ['Initialtext', [Validators.required]],
  });

  constructor(private fb: UntypedFormBuilder, private dateFormatService: QPointDateFormatService) {
    console.log(this.form);
  }

  ngAfterViewInit() {
    this.data$.next(this.initialData);
  }

  ngOnDestroy(): void {
    this.data$.complete();
  }

  submit() {
    console.log(this.form);
    this.form.markAllAsTouched();
  }

  resetForm() {
    this.form.reset();
    console.log(this.form);
  }

  toggleDisabled() {
    this.form.disabled ? this.form.enable() : this.form.disable();
  }

  get dateTimePickerMinMax() {
    return this.form.get('dateTimePickerMinMax') as UntypedFormControl;
  }

  dateValidatorMinMax (): ValidatorFn {
    return (control: UntypedFormControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const value = startOfDay(new Date(control.value));
      if (value.getTime() < this.minDate.getTime() || value.getTime() > this.maxDate.getTime()) {
        return {
          pavingOperationLotDateValidation: {
            value: 'common.validators.dateTimePickerDateMismatch',
            parameter: `${this.dateFormatService.format(this.minDate, QPointDateFormat.ShortDate)}, ${this.dateFormatService.format(this.maxDate, QPointDateFormat.ShortDate)}`
          }
        };
      }
      return null;
    }
  }
}
